var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.keyWords.length > 1
    ? _c(
        "ul",
        {
          staticClass: "row list-unstyled px-1 mb-0",
          attrs: { "aria-label": "Attributs de l'offre" },
        },
        _vm._l(_vm.keyWords, function (keyword, index) {
          return _c(
            "li",
            { key: index, staticClass: "col-auto px-0 pb-1" },
            [
              keyword
                ? _c("status-tag", {
                    key: index,
                    attrs: { version: "reminder", label: keyword },
                  })
                : _vm._e(),
            ],
            1
          )
        }),
        0
      )
    : _c(
        "div",
        {
          staticClass: "row px-1 mb-0",
          attrs: { "aria-label": "Attribut de l'offre" },
        },
        _vm._l(_vm.keyWords, function (keyword, index) {
          return _c(
            "div",
            { key: index, staticClass: "col-auto px-0 pb-1" },
            [
              keyword
                ? _c("status-tag", {
                    key: index,
                    attrs: { version: "reminder", label: keyword },
                  })
                : _vm._e(),
            ],
            1
          )
        }),
        0
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }